import React from 'react';
import SafePureComponent from "@manual_encounters/encounter_reconcile/pings/common/SafePureComponent";

class PingStateText extends SafePureComponent {
  safeRender() {
    const {
      ping: { state },
    } = this.props;
    return (
      <span data-testid="ping-status-text">
        {state}
      </span>
    );
  }
}

export default PingStateText;
